import { useNavigate } from "react-router-dom";
import Header from "../component/Header";
import TabelaItens from "../component/TabelaItens";
import useApp from "../context/AppContext";

const InserirItensDocumento = () => {
  const {usuario, setUsuario,showModalMessage, itensPedido} = useApp();
  const navigate = useNavigate();  
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {  
      
    const user = {...usuario}
    if (user.novoDocumento)
      user.novoDocumento.itens = itensPedido?.filter(item => item.checked)
  
    if (itensPedido?.filter(item => item.checked).length === 0)
      showModalMessage("Selecione os itens", <h2>É necessário selecionar os serviços executados nessa {usuario.novoDocumento?.tipo}.</h2>)
    else {
      setUsuario(user)
      navigate("/dadosAdicionais")
    }
    event.preventDefault();
  };
  return (
    <div className="limiter altbg4">
      <div className="container-interna">
        <div className="wrap-interna p-t-25 p-b-20">
          <Header/>

          <div className="insere-fatura-etp2-wrap">
            <form onSubmit={handleSubmit}>
              <h1 className="text-center pb-5">Inserir {usuario.novoDocumento?.tipo}</h1>

              <p className="h5 text-center pb-4 color-3e3e3e">Marque abaixo os serviços que serão atribuídos a esta {usuario.novoDocumento?.tipo}</p>
              <div className="form-row">
                <TabelaItens itens={itensPedido} />                
              </div>

              <div className="bot-inserir-fatura mt-5 d-flex flex-row-reverse">
                <button type="submit" className="btn btn-primary">
                  Avançar
                </button>
                <button className="btn btn-secondary" onClick={() => navigate("/inserirDocumento")}>
                  Voltar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InserirItensDocumento;
